import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { fetchToken } from "./Auth";
import "../css/estatisticasProjeto.css";

function EstatisticasProjeto() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [projeto, setProjeto] = useState(null);
  const [valorGasto, setValorGasto] = useState(0);

  useEffect(() => {
    const fetchDados = async () => {
      try {
        const token = fetchToken(); // 1. Pega o Token
        if (!token) throw new Error("Token não encontrado.");

        // 2. CORREÇÃO AQUI: Enviar o token no Header
        const resProjeto = await axios.get(
          `/api/projetocompleto/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }, // <--- ADICIONADO
        );

        if (
          resProjeto.data.Status === "Success" &&
          resProjeto.data.Result.length > 0
        ) {
          setProjeto(resProjeto.data.Result[0]);
        } else {
          throw new Error("Projeto não encontrado ou acesso negado.");
        }

        // Busca Cronograma (já estava correto, mas mantive a estrutura)
        try {
          const resCronograma = await axios.get(
            `/api/cronograma/${id}`,
            { headers: { Authorization: `Bearer ${token}` } },
          );

          const itensDoCronograma = resCronograma.data || [];
          const somaTotalGasto = itensDoCronograma.reduce((accItens, item) => {
            const parcelas = item.mensal || [];
            return (
              accItens +
              parcelas.reduce(
                (acc, parcela) => acc + parseFloat(parcela.valor_simples || 0),
                0,
              )
            );
          }, 0);

          setValorGasto(somaTotalGasto);
        } catch (cronogramaErr) {
          console.error("Erro cronograma:", cronogramaErr.message);
          setValorGasto(0);
        }
      } catch (error) {
        console.error("Erro projeto:", error);
        alert("Erro ao carregar projeto. Verifique sua permissão.");
      } finally {
        setLoading(false);
      }
    };
    fetchDados();
  }, [id]);

  const calcularProgressoEtapa = (inicio, fim, situacao) => {
    if (!inicio || !fim) return 0;
    const hoje = new Date();
    const dataInicio = new Date(inicio);
    const dataFim = new Date(fim);

    if ((situacao || "").toLowerCase() === "concluído") return 100;
    if (hoje < dataInicio) return 0;
    if (hoje > dataFim) return 100;

    const totalDias = (dataFim - dataInicio) / (1000 * 3600 * 24);
    if (totalDias <= 0) return 100;
    const diasPassados = (hoje - dataInicio) / (1000 * 3600 * 24);
    return Math.round((diasPassados / totalDias) * 100);
  };

  // --- Renderização de Loading ---
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center">
          <div className="spinner-border text-primary mb-2" role="status"></div>
          <p className="text-muted">Carregando estatísticas...</p>
        </div>
      </div>
    );
  }

  if (!projeto) {
    return (
      <div className="container mt-5 text-center">
        <h3>Projeto não encontrado.</h3>
        <Link to="/projetocompleto" className="btn btn-primary mt-3">
          Voltar
        </Link>
      </div>
    );
  }

  // --- Lógica de Apresentação ---
  const valorOrcadoTotal = parseFloat(projeto.valor_repasse) || 0; // Ajuste se quiser somar contrapartida
  const valorRestante = Math.max(0, valorOrcadoTotal - valorGasto);
  const percentualGasto =
    valorOrcadoTotal > 0
      ? Math.round((valorGasto / valorOrcadoTotal) * 100)
      : 0;

  const etapas = [1, 2, 3, 4, 5, 6].map((n) => {
    const inicio = projeto[`data_inicio_etapa${n}`];
    const fim = projeto[`data_termino_etapa${n}`];
    const situacao = projeto[`situacao_etapa${n}`];

    return {
      id: n,
      nome: projeto[`etapa${n}`] || `Etapa ${n}`,
      inicio: inicio ? new Date(inicio).toLocaleDateString("pt-BR") : "-",
      fim: fim ? new Date(fim).toLocaleDateString("pt-BR") : "-",
      situacao: situacao || "Não iniciado",
      progresso: calcularProgressoEtapa(inicio, fim, situacao),
      rawInicio: inicio,
      rawFim: fim,
    };
  });

  // Determinar etapa atual para destaque
  let etapaAtual = etapas.find(
    (e) => (e.situacao || "").toLowerCase() === "em andamento",
  );
  if (!etapaAtual)
    etapaAtual = etapas.find(
      (e) => (e.situacao || "").toLowerCase() === "não iniciado",
    );
  if (!etapaAtual) etapaAtual = etapas[etapas.length - 1];

  const progressoEtapaAtual = etapaAtual.progresso;
  const hoje = new Date();
  const dataFimEtapaAtual = etapaAtual.rawFim
    ? new Date(etapaAtual.rawFim)
    : null;
  const isAtrasada =
    (etapaAtual.situacao || "").toLowerCase() === "em andamento" &&
    dataFimEtapaAtual &&
    hoje > dataFimEtapaAtual;

  // Helper para cor do badge
  const getBadgeClass = (status) => {
    const s = (status || "").toLowerCase();
    if (s.includes("concluído")) return "concluido";
    if (s.includes("andamento")) return "andamento";
    if (s.includes("atrasado")) return "atrasado";
    return "nao-iniciado";
  };

  return (
    <div className="stats-container">
      {/* 1. Header Escuro */}
      <div className="header-stats">
        <div>
          <h1 className="header-title">Painel Estatístico</h1>
          <span style={{ opacity: 0.8, fontSize: "0.9rem" }}>
            Projeto: {projeto.nomeprojeto}
          </span>
        </div>
        <Link to={`/viewprojetocompleto/${id}`} className="btn-back-custom">
          <i className="fas fa-arrow-left"></i> Voltar ao Projeto
        </Link>
      </div>

      <div className="stats-content">
        <div className="row g-4">
          {/* 2. Card Financeiro (Gasto x Orçado) */}
          <div className="col-lg-4 col-md-6">
            <div className="stat-card">
              <div className="stat-card-title">
                <i className="fas fa-wallet me-2"></i> Execução Orçamentária
              </div>

              <div className="mb-4">
                <span className="stat-label-small d-block">
                  Valor Total Orçado (Repasse)
                </span>
                <span className="stat-value-large text-primary">
                  R${" "}
                  {valorOrcadoTotal.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </div>

              <div className="row mb-3">
                <div className="col-6">
                  <span className="stat-label-small fw-bold">Executado</span>
                  <div className="fs-5 text-dark">
                    R${" "}
                    {valorGasto.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </div>
                </div>
                <div className="col-6 text-end">
                  <span className="stat-label-small fw-bold">Disponível</span>
                  <div className="fs-5 text-success">
                    R${" "}
                    {valorRestante.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>

              <div className="mt-auto">
                <div className="d-flex justify-content-between mb-1">
                  <span className="small text-muted">Consumo do orçamento</span>
                  <span className="small fw-bold">{percentualGasto}%</span>
                </div>
                <div className="progress-container-custom">
                  <div
                    className={`progress-bar-custom ${percentualGasto > 90 ? "bg-danger" : "bg-success"}`}
                    style={{ width: `${percentualGasto}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Card Etapa Atual (Foco no Progresso de Tempo) */}
          <div className="col-lg-4 col-md-6">
            <div
              className="stat-card"
              style={{
                borderTopColor: isAtrasada
                  ? "var(--danger)"
                  : "var(--blue-primary)",
              }}
            >
              <div className="stat-card-title">
                <i className="fas fa-clock me-2"></i> Etapa Vigente
              </div>

              <h4 className="fw-bold mb-3 text-dark">{etapaAtual.nome}</h4>

              <div className="d-flex justify-content-between mb-4 p-3 bg-light rounded">
                <div className="text-center">
                  <small
                    className="text-muted d-block text-uppercase"
                    style={{ fontSize: "0.7rem" }}
                  >
                    Início
                  </small>
                  <strong>{etapaAtual.inicio}</strong>
                </div>
                <div className="align-self-center text-muted">
                  <i className="fas fa-arrow-right"></i>
                </div>
                <div className="text-center">
                  <small
                    className="text-muted d-block text-uppercase"
                    style={{ fontSize: "0.7rem" }}
                  >
                    Término Previsto
                  </small>
                  <strong>{etapaAtual.fim}</strong>
                </div>
              </div>

              <div className="mt-auto">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span
                    className={`status-badge ${getBadgeClass(isAtrasada ? "atrasado" : etapaAtual.situacao)}`}
                  >
                    {isAtrasada ? "ATRASADO" : etapaAtual.situacao}
                  </span>
                  <span className="fw-bold">
                    {progressoEtapaAtual}% do tempo
                  </span>
                </div>

                <div className="progress-container-custom">
                  <div
                    className={`progress-bar-custom ${isAtrasada ? "bg-danger" : "bg-primary"}`}
                    style={{ width: `${progressoEtapaAtual}%` }}
                  ></div>
                </div>
                {isAtrasada && (
                  <small className="text-danger mt-1 d-block">
                    <i className="fas fa-exclamation-triangle"></i> Atenção: O
                    prazo desta etapa expirou.
                  </small>
                )}
              </div>
            </div>
          </div>

          {/* 4. Lista de Todas as Etapas (Timeline) */}
          <div className="col-lg-4 col-md-12">
            <div className="stat-card">
              <div className="stat-card-title">
                <i className="fas fa-list-ul me-2"></i> Cronograma Geral
              </div>

              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "400px",
                  margin: "-1rem",
                }}
              >
                <ul className="timeline-list">
                  {etapas.map((etapa) => {
                    const isActive = etapa.id === etapaAtual.id;
                    return (
                      <li
                        key={etapa.id}
                        className={`timeline-item ${isActive ? "active-stage" : ""}`}
                      >
                        <div className="timeline-info">
                          <strong>{etapa.nome}</strong>
                          <div className="timeline-dates">
                            <i className="far fa-calendar-alt me-1"></i>{" "}
                            {etapa.inicio} - {etapa.fim}
                          </div>
                        </div>
                        <div className="text-end">
                          <span
                            className={`status-badge ${getBadgeClass(etapa.situacao)}`}
                          >
                            {etapa.situacao || "---"}
                          </span>
                          {isActive && (
                            <div className="small text-primary mt-1 fw-bold">
                              Atual
                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstatisticasProjeto;
